import { Box } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { trackEvent } from '~/features/analytics/track-event';
import { ClaudeEngineerExperiencePromoCard } from '~/features/claude-engineer-2026/components/claude-engineer-experience-promo-card';
import { EXPERIENCE_CTA_ANALYTICS_LABEL } from '~/features/claude-engineer-2026/constants';
import type { ClaudeEngineerVariant } from '~/features/claude-engineer-2026/models/variant';
import { MastersAIPromoCard } from '~/features/experiments/ab_plp_redesign_2025/components/promo-card';

function ExperiencePromoBannerLayout({ children }: { children: React.ReactNode }) {
  return (
    <Box paddingBottom={{ base: '56px', md: '112px' }} paddingTop={{ base: '56px', md: '112px' }}>
      <ContentContainer contentMaxWidth='content-max-width-lg'>{children}</ContentContainer>
    </Box>
  );
}

export function ExperiencePromoBannerSection() {
  return (
    <ExperiencePromoBannerLayout>
      <MastersAIPromoCard
        onClick={() => {
          trackEvent({
            label: 'masters_entry_clicked',
            name: 'ExperiencePage CTA Clicked',
            type: 'click',
          });
        }}
      />
    </ExperiencePromoBannerLayout>
  );
}

export function ClaudeEngineerExperiencePromoBannerSection({ variant }: { variant: ClaudeEngineerVariant }) {
  return (
    <ExperiencePromoBannerLayout>
      <ClaudeEngineerExperiencePromoCard
        variant={variant}
        onClick={() => {
          trackEvent({
            label: EXPERIENCE_CTA_ANALYTICS_LABEL,
            name: 'ExperiencePage CTA Clicked',
            type: 'click',
          });
        }}
      />
    </ExperiencePromoBannerLayout>
  );
}
